<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getCurrentUser } from '@/api/auth'

export default {
  name: 'App',
  async created() {
    if (!localStorage.getItem('accessToken')) {
      return
    }
    try {
      const user = await getCurrentUser()
      localStorage.setItem('userInfo', JSON.stringify(user))
      localStorage.setItem('permissions', JSON.stringify(user.permissions || []))
      window.dispatchEvent(new Event('permissions-updated'))
    } catch (error) {
      // 获取失败时不在这里做跳转，交给路由守卫处理
      localStorage.removeItem('userInfo')
      localStorage.removeItem('permissions')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  height: 100vh;
  width: 100vw;
}
</style>

